module.exports = __webpack_public_path__ + "img/0-2.4c2e04eb.png";